import { createAsyncThunk } from "@reduxjs/toolkit";
import { config } from "./api/config";

export const fetchConfig = createAsyncThunk("config", async () => {
  const response = await config();
  return response?.data;
});
